class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    /* Defer body click listener so the opening click doesn't immediately close */
    var self = this;
    setTimeout(function() { document.body.addEventListener('click', self.onBodyClickEvent); }, 0);
    /* Save scroll position before locking */
    this._savedScrollY = window.scrollY;
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden-html');
    document.body.style.top = -this._savedScrollY + 'px';

    /* White header background when search modal is open */
    if (this.classList.contains('header__search')) {
      /* Ensure header is visible before opening search */
      var sectionHeader = this.closest('.section-header');
      if (sectionHeader) {
        sectionHeader.classList.remove('shopify-section-header-hidden');
        sectionHeader.classList.add('shopify-section-header-sticky');
        /* Force fixed positioning so header stays visible with body scroll lock
           (position:sticky breaks inside position:fixed body) */
        sectionHeader.style.setProperty('position', 'fixed', 'important');
        sectionHeader.style.setProperty('top', '0', 'important');
        sectionHeader.style.setProperty('left', '0', 'important');
        sectionHeader.style.setProperty('right', '0', 'important');
        sectionHeader.style.setProperty('z-index', '1000', 'important');
      }

      var headerWrapper = sectionHeader?.querySelector('.header-wrapper');
      if (headerWrapper) {
        headerWrapper.classList.add('header-wrapper--search-open');
        headerWrapper.style.setProperty('background', '#fff', 'important');
        headerWrapper.style.setProperty('background-color', '#fff', 'important');
        headerWrapper.style.setProperty('color', '#004e32', 'important');
        /* Force dark colors on all header elements */
        headerWrapper.querySelectorAll('a, span, summary, .header__menu-item, .header__icon').forEach(function(el) {
          el.dataset.origColor = el.style.color;
          el.style.setProperty('color', '#004e32', 'important');
        });
        headerWrapper.querySelectorAll('svg path, svg circle, svg rect, svg polygon').forEach(function(el) {
          el.style.setProperty('fill', '#004e32', 'important');
        });
        /* Fix logo image — remove white invert filter */
        var logoImg = headerWrapper.querySelector('.header__heading-link img');
        if (logoImg) logoImg.style.setProperty('filter', 'none', 'important');
        /* Position search modal below header — getBoundingClientRect is now
           accurate because sectionHeader is position:fixed.
           On mobile the header layout collapses (only the search input is
           shown) so we anchor the modal to the top of the viewport instead
           of chasing the shrunken header-bottom (~13px). */
        var searchModal = this.querySelector('.search-modal');
        if (searchModal) {
          var isMobile = window.matchMedia('(max-width: 749px)').matches;
          if (isMobile) {
            searchModal.style.setProperty('top', '0', 'important');
            searchModal.style.setProperty('height', '100vh', 'important');
          } else {
            var headerBottom = headerWrapper.getBoundingClientRect().bottom;
            searchModal.style.setProperty('top', headerBottom + 'px', 'important');
            searchModal.style.setProperty('height', 'calc(100vh - ' + headerBottom + 'px)', 'important');
          }
        }
      }
    }

    /* Prevent touch scroll on background (iOS) */
    this._preventTouchMove = function(e) {
      var scrollable = e.target.closest('.search-modal__content, .menu-drawer__inner-submenu, .menu-drawer__navigation-container');
      if (!scrollable) e.preventDefault();
    };
    document.addEventListener('touchmove', this._preventTouchMove, { passive: false });

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden-html');
    document.body.style.removeProperty('top');
    /* Remove touch scroll prevention */
    if (this._preventTouchMove) {
      document.removeEventListener('touchmove', this._preventTouchMove);
    }
    /* Restore scroll position */
    if (this._savedScrollY !== undefined) {
      window.scrollTo(0, this._savedScrollY);
    }

    /* Restore header background */
    if (this.classList.contains('header__search')) {
      /* Remove forced fixed positioning from section header */
      var sectionHeader = this.closest('.section-header');
      if (sectionHeader) {
        sectionHeader.style.removeProperty('position');
        sectionHeader.style.removeProperty('top');
        sectionHeader.style.removeProperty('left');
        sectionHeader.style.removeProperty('right');
        sectionHeader.style.removeProperty('z-index');
      }
      /* Remove inline positioning from search modal */
      var searchModal = this.querySelector('.search-modal');
      if (searchModal) {
        searchModal.style.removeProperty('top');
        searchModal.style.removeProperty('height');
      }
      var headerWrapper = sectionHeader?.querySelector('.header-wrapper');
      if (headerWrapper) {
        headerWrapper.classList.remove('header-wrapper--search-open');
        headerWrapper.style.removeProperty('background');
        headerWrapper.style.removeProperty('background-color');
        headerWrapper.style.removeProperty('color');
        /* Restore original colors */
        headerWrapper.querySelectorAll('[data-orig-color]').forEach(function(el) {
          el.style.setProperty('color', el.dataset.origColor || '', 'important');
          delete el.dataset.origColor;
        });
        headerWrapper.querySelectorAll('svg path, svg circle, svg rect, svg polygon').forEach(function(el) {
          el.style.removeProperty('fill');
        });
        /* Restore logo image filter */
        var logoImg = headerWrapper.querySelector('.header__heading-link img');
        if (logoImg) logoImg.style.removeProperty('filter');
      }
    }
  }
}

customElements.define('details-modal', DetailsModal);
